import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  GenerateStatementFormValues,
  GenerateStatementResponseDto,
} from '../model';
import { buildStatementParams } from '../lib';
import type { OperationFilter } from '@/shared/types';

const generateStatement = async (
  filter: OperationFilter,
  data: GenerateStatementFormValues,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get(`/operations/list/${filter}/statement`, {
      params: buildStatementParams(data),
    });
  const response = await handleRequest<GenerateStatementResponseDto>(
    request,
    options
  );
  return response.data;
};

export { generateStatement };
